// extracted by mini-css-extract-plugin
module.exports = {"button":"_9400a595a7--button--tmiJO"};